import { Link } from "react-router-dom";

// Shared page frame used by /privacy and /terms so they inherit the site
// chrome and stay consistent with the rest of the property.
export default function LegalPageLayout({ title, effectiveDate, children }) {
  return (
    <div className="min-h-screen bg-black text-white grain">
      <div className="border-b border-white/10 px-4 md:px-10 py-6 md:py-8">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link
            to="/"
            aria-label="Philadelphia Freeway home"
            className="inline-flex items-center gap-3 group"
          >
            <img
              src="/assets/logos/logo_gold.png"
              alt="Philadelphia Freeway"
              className="w-10 h-10 object-contain"
            />
            <span className="font-wide uppercase text-white text-sm md:text-base tracking-tight group-hover:text-[#F4C10A] transition-colors">
              Philadelphia Freeway
            </span>
          </Link>
        </div>
      </div>

      <main className="px-4 md:px-10 py-14 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-3">
            Legal
          </div>
          <h1 className="font-wide text-white uppercase text-4xl md:text-5xl leading-[0.95]">
            {title}
          </h1>
          <div className="mt-3 font-mono text-[11px] tracking-[0.25em] uppercase text-white/50">
            Effective Date: {effectiveDate}
          </div>

          <article
            data-testid="legal-body"
            className="mt-10 space-y-8 font-body text-white/80 text-base md:text-[17px] leading-relaxed"
          >
            {children}
          </article>

          <div className="mt-14 pt-8 border-t border-white/10 flex flex-wrap gap-4 justify-between items-center">
            <Link
              to="/"
              className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/60 hover:text-[#F4C10A] transition-colors"
            >
              ← Back to Home
            </Link>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
              © 2003–2026 · FTA X PLANES · PHILLY
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export function LegalHeading({ children }) {
  return (
    <h2 className="font-wide text-white uppercase text-lg md:text-xl tracking-tight mt-2">
      {children}
    </h2>
  );
}
